import { ChangeEvent, CSSProperties, FC } from 'react';

import cleanText from 'utils/cleanText';
import CommentsCharCounter from '../CommentsCharCounter';

type InputTextAreaProps = {
  communicationInput?: boolean;
  description?: string;
  id: string;
  infoLabel?: string;
  label?: string;
  lgSize?: boolean;
  maxLength?: number;
  noResize?: boolean;
  onChange: (value: string) => void; // eslint-disable-line
  onlyInput?: boolean;
  placeholder?: string;
  rows?: number;
  showCounter?: boolean;
  style?: CSSProperties;
  value: string;
};

const InputTextArea: FC<InputTextAreaProps> = ({
  communicationInput = false,
  description,
  id,
  infoLabel,
  label,
  lgSize = false,
  maxLength = 3000,
  noResize = false,
  onChange,
  onlyInput = false,
  placeholder = '',
  rows = 4,
  showCounter = true,
  style = {},
  value,
}) => {
  const handleChangeInput = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;
    const sanitizedText = cleanText(value);

    onChange(sanitizedText);
  };

  const inputClassName = communicationInput
    ? 'form-control form-control-simple no-resize ex-large'
    : `form-control ${noResize ? 'no-resize h-auto' : ''} ${
        lgSize ? 'override-min-height form-control-lg' : ''
      }`;

  const textAreaComponent = (
    <textarea
      id={id}
      className={inputClassName}
      placeholder={placeholder}
      value={value}
      maxLength={maxLength}
      onChange={handleChangeInput}
      rows={rows}
      style={style}
    />
  );

  return (
    <>
      {communicationInput || onlyInput ? (
        textAreaComponent
      ) : (
        <div className="form-group">
          {label && (
            <label className="form-label" htmlFor={id}>
              {label}
              {description && (
                <span className="d-block text-muted small">{description}</span>
              )}
            </label>
          )}
          <div className="form-control-wrap">
            {textAreaComponent}

            {showCounter && (
              <div
                className={`form-note d-flex ${
                  infoLabel ? 'justify-content-between' : 'justify-content-end'
                } mt-2`}
              >
                {infoLabel}
                <CommentsCharCounter comments={value} maxLength={maxLength} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InputTextArea;
